import { lazy } from 'react';
import { Route } from 'react-router-dom';

import { routePaths } from 'modules/auth/constants';

const Maintenance = lazy(() => import('./maintenance'));

export default {
  routes: [
    <Route
      exact
      key={routePaths.maintenance}
      path={routePaths.maintenance}
      render={() => <Maintenance />}
    />,
  ],
};
